export enum TableStatus {
  FREE = 'FREE',

  ASSIGNED = 'ASSIGNED',

  BLOCKED = 'BLOCKED',
}
